<template>
  <PageContainer title="Enviar avisos para Auto Escolas">
    <div class="loading" v-if="!loaded">
      <LoadingSpinner />
    </div>

    <Box space="medium" v-else class="avisos-container">
      <Box color="bg-gray" class="recipient-section">
        <div class="format-container">
          <span>Selecione o tipo de notificação</span>

          <RadioButtons :options="radioTypeOptions" name="type" :modelValue="type"
            @update:modelValue="$event => type = $event" />
        </div>
      </Box>

      <Box color="bg-gray" class="recipient-section">
        <div class="format-container">
          <span>Selecione o Destinatário</span>

          <RadioButtons :options="radioOptions" name="format" :modelValue="format"
            @update:modelValue="$event => format = $event" />
        </div>

        <Box v-if="format === 'schema'">
          <Select :options="schemaOptions" legend="Autoescola" placeholder="Selecione uma autoescola"
            :modelValue="schema" @update:modelValue="$event => (schema = $event)" :disabled="loading" />
        </Box>

        <Box v-if="format === 'user'">
          <Select :options="userOptions" legend="Usuário" placeholder="Selecione um usuário" :modelValue="user"
            @update:modelValue="$event => (user = $event)" :disabled="loading" />
        </Box>
      </Box>

      <div class="message-section">
        <h2>Mensagem</h2>

        <Box color="bg-gray">
          <Box class="message-content">
            <Input class="input-full" :modelValue="title" @update:modelValue="$event => (title = $event)"
              legend="Título" placeholder="Título" :disabled="loading" />

            <Editor v-model="content" />

            <Input class="input-full" :modelValue="link" @update:modelValue="$event => (link = $event)"
              legend="Link (Opcional)" placeholder="Link" :disabled="loading" />

            <div class="upload-input">
              <span>Anexos (Opcional)</span>

              <FileUpload v-model="attachments" />
            </div>
          </Box>
        </Box>
      </div>

      <div>
        <div class="buttons">
          <Button type="button" text="Limpar" :fill="false" color="danger" :disabled="loading"
            @handle:click="clearInputs">
            <CloseCircleOutline :size="18" />
          </Button>

          <Button type="button" text="Enviar" color="primary" :disabled="loading" @handle:click="handleSubmit">
            <SendVariantOutline :size="18" />
          </Button>
        </div>
      </div>
    </Box>
  </PageContainer>
</template>

<script>
import Box from 'core/Box'
import Button from 'core/Button'
import Input from 'core/Input'
import LoadingSpinner from 'core/LoadingSpinner'
import RadioButtons from 'core/RadioButtons'
import PageContainer from 'core/PageContainer'
import Textarea from 'core/Textarea'
import Editor from 'core/editor'
import FileUpload from 'core/filepond'
import Select from 'core/Select'
import CloseCircleOutline from 'icons/CloseCircleOutline'
import Magnify from 'icons/Magnify'
import SendVariantOutline from 'icons/SendVariantOutline'
import Multiselect from 'vue-multiselect'

export default {
  name: 'form_avisos',
  components: {
    PageContainer,
    Box,
    LoadingSpinner,
    RadioButtons,
    Editor,
    Input,
    FileUpload,
    Button,
    Textarea,
    Select,
    CloseCircleOutline,
    Magnify,
    SendVariantOutline,
  },
  data() {
    return {
      type: 'notification',
      format: 'all',
      title: '',
      content: '',
      link: '',
      schema: null,
      user: null,
      radioTypeOptions: [
        { value: "notification", label: "Notificação" },
        { value: "version_control", label: "Atualização" },
      ],
      radioOptions: [
        { value: "all", label: "Enviar para todos" },
        { value: "schema", label: "Enviar para autoescola" },
        { value: "user", label: "Enviar para usuário" },
      ],
      schemaOptions: [],
      userOptions: [],
      attachments: [],

      destinatario: 'autoescola',
      aviso: '',
      loaded: false,
      loading: false,
    }
  },
  async created() {
    await Promise.all([
      this.fetchCfcs(),
      this.fetchUsuarios(),
    ])

    this.loaded = true
  },
  methods: {
    async fetchCfcs() {
      await this.$http
        .get(`${process.env.VUE_APP_URL_API_V2}/autoescola/todas`)
        .then(res => {
          this.schemaOptions = res.body.dados.map(cfc => ({
            value: cfc.tenant_schema,
            text: cfc.nome_fantasia,
          }))
        })
        .catch(error => {
          this.$toasted.show('Erro!' + error.body.mensagem, {
            position: 'top-right',
          })
        })
    },
    async fetchUsuarios() {
    },
    clearInputs() {
      this.schema = null
      this.user = null
      this.title = ''
      this.content = ''
      this.link = ''
      this.format = 'all'
      this.type = 'notification'
      this.attachments = []
    },
    async handleSubmit() {
      if (this.validateInputs()) {
        this.loading = true

        const formData = new FormData();
        formData.append('type', this.type)

        formData.append('title', this.title)
        formData.append('description', this.content)

        if (this.schema) {
          formData.append('schema', this.schema)
        }

        if (this.link) {
          formData.append('link', this.link)
        }

        if (this.user) {
          formData.append('userId', this.user)
        }

        if (this.attachments && this.attachments.length > 0) {
          this.attachments.forEach((file, index) => {
            console.log(file)
            formData.append(`attachments[${index}]`, file.file)
          });
        }

        await this.$http
          .post(`${process.env.VUE_APP_URL_API_V2}/notificacoes`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(res => {
            this.$toasted.show(res.body.mensagem, {
              icon: 'fa-check',
              position: 'top-right',
              duration: 5000,
              fullWidth: false,
            })

            this.$router.push({ name: 'notifications' })
          })
          .catch(err => {
            this.$toasted.show(err.body.mensagem, {
              icon: 'fa-warning',
              position: 'top-right',
              duration: 5000,
              fullWidth: false,
            })
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    validateInputs() {
      if (this.format === 'schema' && !this.schema) {
        this.$toasted.show('Selecione uma auto escola', {
          icon: 'fa-warning',
          position: 'top-right',
          duration: 5000,
          fullWidth: false,
        })
        return false
      }

      if (!this.title) {
        this.$toasted.show('Preencha o título da notificação.', {
          icon: 'fa-warning',
          position: 'top-right',
          duration: 5000,
          fullWidth: false,
        })
        return false
      }

      if (!this.content) {
        this.$toasted.show('Preencha o conteúdo da notificação.', {
          icon: 'fa-warning',
          position: 'top-right',
          duration: 5000,
          fullWidth: false,
        })
        return false
      }
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
}

.avisos-container {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  .recipient-section {
    display: flex;
    flex-direction: column;
    gap: 2rem;

    .format-container {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      span {
        font-size: 1rem;
        font-weight: 600;
        line-height: 21.82px;
        color: #606264;
      }
    }
  }

  .message-section {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    h2 {
      margin: 0;
      font-weight: 700;
      font-size: 1.375rem;
      line-height: 100%;
      letter-spacing: -0.11px;
      color: #202224;
    }

    .message-content {
      display: flex;
      flex-direction: column;
      gap: 2rem;

      .upload-input {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;

        span {
          margin: 0;
          font-size: 1rem;
          font-weight: 600;
          line-height: 100%;
          color: #606264;
        }
      }
    }
  }

  .buttons {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
  }
}

.input-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  legend {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    line-height: 21.82px;
    color: #606264;
  }

  .input {
    min-width: 15.0625rem !important;
    height: 2.738125rem !important;
    border: 1px solid #eaeaea !important;
    border-radius: 4px !important;
    font-size: 1rem;
    font-weight: 600;
    line-height: 21.82px;
  }

  .radio-group {
    display: flex;
    gap: 1rem;
    margin-top: 0.5rem;

    label {
      display: flex;
      align-items: center;
      gap: 0.25rem;
    }
  }
}

.main-form {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  .inputs {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

    .inputs-row {
      display: flex;
      flex-wrap: wrap;
      gap: 1.5rem;

      .input-full {
        flex: 1;
      }
    }
  }

  .buttons {
    align-self: flex-end;
    display: flex;
    gap: 0.5rem;
  }
}
</style>